import { Box, createStyles, Group, Stack, ThemeIcon } from '@mantine/core';
import { EntityType } from '@repo/common/enums/entityType';
import { isTestStatusSuccessful } from '@repo/common/utils';
import { Text } from '@repo/foundations';
import { IconCheck, IconX } from '@tabler/icons-react';
import moment from 'moment';
import type { ILineageTableTest } from '../../../api';
import IntegrationLogo from '../../IntegrationLogo';
import LineageListItemDetails from '../Legacy/LineageListItemDetails';
import LineageListItemTitle from '../Legacy/LineageListItemTitle';

interface ITestRunItemProps {
	test: ILineageTableTest;
}

const useStyles = createStyles((theme) => ({
	container: {
		padding: `${theme.spacing.sm} ${theme.spacing.md}`,
	},
	group: {
		width: '100%',
	},
}));

function TestRunItem({ test }: ITestRunItemProps) {
	const { classes } = useStyles();

	const getTestColor = (status: string) =>
		isTestStatusSuccessful(status) ? 'green' : 'red';

	const getTestIcon = (status: string) =>
		isTestStatusSuccessful(status) ? (
			<IconCheck size={12} />
		) : (
			<IconX size={12} />
		);

	return (
		<Box className={classes.container}>
			<Group className={classes.group} position="apart">
				<Group>
					<IntegrationLogo
						entityType={EntityType.test}
						integrationId={test.integration || test.integration_id}
						width={20}
						height={20}
					/>
					<Stack spacing={0}>
						<LineageListItemTitle title={test.title} length={64} />
						<LineageListItemDetails
							entityType={EntityType.test}
							metadata={
								test.suite_title ? { suite_title: test.suite_title } : {}
							}
						/>
					</Stack>
				</Group>
				<Group position="apart">
					<Text size="xs" color="text/secondary/default">
						{test?.latest_run?.run_created_at
							? moment(test.latest_run.run_created_at).fromNow()
							: 'N/A'}
					</Text>
					{test?.latest_run?.status && (
						<ThemeIcon
							size="xs"
							variant="light"
							radius="sm"
							color={getTestColor(test.latest_run.status)}
						>
							{getTestIcon(test?.latest_run?.status)}
						</ThemeIcon>
					)}
				</Group>
			</Group>
		</Box>
	);
}

export default TestRunItem;
